module.exports = __webpack_public_path__ + "img/animator.b089f55e.png";